<template>

    <div class="container-fluid">

        <div id="accordion">
            <div class="card">
                <div class="card-header" v-on:click="show = !show">
                    <div class="row px-3">
                        <div>
                            <button class="all-btn add-btn">{{$t("main.search")}} .... </button>
                        </div>
                        <div class="px-3">
                            <button class="all-btn" @click="initList">{{$t("main.search")}}
                            </button>
                        </div>
                        <div>
                            <p style="color: #18ce0f">
                                <button class="all-btn" @click.prevent="reportXslx()">
                                    {{$t("accounting.account.report")}}
                                </button>
                            </p>
                        </div>
                    </div>
                </div>

                <div v-if="show" id="collapseOne" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div  class="col-xl-2 col-lg-3 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>
                                <select class="form-control" v-model="province.id" @change="onProvinceChange">
                                    <option value=""></option>
                                    <option :value="option.id" v-for="option in provinces" :key="option.id">
                                        {{option.name}}
                                    </option>
                                </select>
                            </div>
                            <div  class="col-xl-2 col-lg-3 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("realEstate.field.region")}} <span class="red">*</span></label>
                                <select class="form-control" v-model="region.id">
                                    <option value=""></option>
                                    <option :value="option.id" v-for="option in regions" :key="option.id">
                                        {{option.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-12 mb-2">
                                <label>{{$t("report.field.agents")}}</label>
                                <v-select v-model="filter.user" label="text"
                                          :options="users"
                                          :filterable="false"
                                          @search="onUsersSearch"
                                          @change="initList"
                                          @search:focus="onUsersFocus">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <template slot="selected-option"
                                              v-if="filter && filter.user && filter.user.name">
                                        <div v-html="filter.user.name"
                                             @click="$eventBus.$emit('search:focus')"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("report.date.startDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.startDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>

                            <div class="col-lg-2 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("report.date.endDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.endDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>

                            <div class="col-xl-2 col-lg-3 col-md-5 col-sm-12">
                                <label>{{$t("report.field.objectType")}}</label>
                                <select v-model="filter.evlObjectType" class="form-control" @change="initList">
                                    <option value="AutoAndFitment" style="font-family:verdana;">Авто ва Асбоб-ускуналар</option>
                                    <option value="RealEstate">Кўчмас мулк</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="evaluationObjectIds.length>0" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                              <button style="background-color: #97181d" class="all-btn m-0"
                                      @click.prevent="requirementPdf()">{{$t("accounting.account.requirement")}}
                              </button>
                            </div>
                            <div class="col-12 col-md-6">
                              <div class="mt-3">
                                Мулклар: <strong>{{evaluationObjectIds}}</strong>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body scroll-card-body table-responsive">
                        <div class="row">
                            <div class="col col-sm-6">
                                <!--<div id="chart2">-->
                                    <!--<vue-apex-charts type="bar" height="350" :options="chartOptions" :series="series"></vue-apex-charts>-->
                                <!--</div>-->

                                <!--<div id="chart">-->
                                    <!--<vue-apex-charts type="pie" :options="chartOptions"-->
                                                     <!--:series="series"></vue-apex-charts>-->
                                <!--</div>-->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <Loading v-if="loading"/>
                                <pie-chart ref="autoFitment"
                                           v-show="!loading"
                                           :title="'Авто ва Асбоб-ускуналар'">
                                </pie-chart>
                                <!--<button @click="updateChart">Update!</button>-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <Loading v-if="loading"/>

                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <div class="loader mt-5 mb-5" v-if="loading"></div>
                        <span class="no-data mt-5 mb-5"
                              v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                    </div>
                    <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                        <div class="col-12 pt-3 pb-3">
                            <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                          :per-page="filter.page.size" @change="onPageChange">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate, formatDateText, findBy} from '@/shared/utils';
    import PieChart from '@/views/reports/chart/PieChart';
    // import VueApexCharts from 'vue-apexcharts'
    import Loading from '@/views/Loading';


    // export const
    export default {
        name: "AgentChart",
        components: {
            'b-pagination': bPagination,
            Datepicker,
            // VueApexCharts,
            Loading,
            PieChart
        },
        data() {
            return {
                loginUserProvinceId: null,
                loading: false,
                show: false,
                filter: initFilterModel(),
                results: null,
                realEstateResults: null,
                resultList: [],
                users: [],
                contractAmountTotal: {
                    ALL: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        agentSalary: 0,
                        agentSalaryPaid: 0,
                        count: 0
                    }
                },

                organization: this.$t("accounting.account.organization"),
                evaluationObjectIds: [],
                organizationListValue: [],
                regions: [],
                provinces: [],
                province: {},
                region: {},
                salePropertyDto: {},
                selectedEvaluationObject: [],
                selectedNumberLot: [],
                // series: [44, 55, 13, 43, 22],
                // chartOptions: {
                //     labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
                //     responsive: [{
                //         breakpoint: 480,
                //         options: {
                //             chart: {
                //                 width: 200
                //             },
                //             legend: {
                //                 position: 'bottom'
                //             }
                //         }
                //     }]
                // }

                series: [{
                    data: [0, 0, 0]
                }],
                chartOptions: {
                    plotOptions: {
                        bar: {
                            barHeight: '100%',
                            distributed: true,
                            horizontal: true,
                            dataLabels: {
                                position: 'bottom'
                            },
                        }
                    },
                    colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
                        '#f48024', '#69d2e7'
                    ],
                    dataLabels: {
                        enabled: true,
                        textAnchor: 'start',
                        style: {
                            colors: ['#000']
                        },
                        formatter: function (val, opt) {
                            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
                        },
                        offsetX: 0,
                        dropShadow: {
                            enabled: true
                        }
                    },

                    stroke: {
                        width: 1,
                        colors: ['#fff']
                    },
                    xaxis: {
                        categories: ['Мажбурий ижро бюроси', 'Божхона бошқармаси', 'Бошқа']
                        // categories: ['South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
                        //     'United States'
                        // ],
                    },
                    yaxis: {
                        labels: {
                            show: false
                        }
                    },
                    title: {
                        text: 'ТАШКИЛОТЛАР',
                        align: 'center',
                        floating: true
                    },
                    subtitle: {
                        text: 'Category Names as DataLabels inside bars',
                        align: 'center',
                    },
                    tooltip: {
                        theme: 'dark',
                        x: {
                            show: false
                        },
                        y: {
                            title: {
                                formatter: function () {
                                    return ''
                                }
                            }
                        }
                    }
                }
            }
        },
        methods: {

            // updateChart() {
            //
            //     // In the same way, update the series option
            //     this.series = [{
            //         data: [0, 0, 0]
            //     }];
            //
            //     this.chartOptions = {
            //             xaxis: {
            //                 categories: ['Мажбурий ижро бюроси', 'Божхона бошқармаси', 'Бошқа']
            //             }
            //         };
            //
            //     // this.chartOptions.xaxis.categories= ['Italy', 'France', 'Japan', 'United States'];
            // },
            initList() {
                this.loading = true;
                this.init();
                this.filter.startDate = formatDate(this.filter.startDate);
                this.filter.endDate = formatDate(this.filter.endDate);
                this.filter.startDate = parseDate(this.filter.startDate);
                this.filter.endDate = parseDate(this.filter.endDate);

                this.filter.page.page = 1;
                this.filter.page.size = 1000000;
                if (this.filter.evlObjectType != null) {
                    if (this.filter.evlObjectType==='AutoAndFitment') {
                        this.filter.objectTypes = ['Auto', 'Fitment'];
                    } else {
                        this.filter.objectTypes = ['Building'];
                    }
                }

                var barTitleText = 'Кўчмас мулк';
                if (this.filter.evlObjectType==='AutoAndFitment') {
                    barTitleText = 'Авто ва Асбоб-ускуналар';
                }

                var barTitle = barTitleText;
                this.$eventBus.$emit('refreshHorizontalBarChart', {barTitle: barTitle});
                this.$eventBus.$emit('refreshMixedBarChart', {barTitle: barTitle});

                var barTitle2 = barTitleText + ' ойлар буйича';
                this.$eventBus.$emit('refreshBarChartMonth', {barTitle: barTitle2});

                if (this.filter.startDate != null && this.filter.endDate != null) {
                    barTitle = barTitleText + ' (' + formatDateText(this.filter.startDate) + ' дан  ' + formatDateText(this.filter.endDate) + ' гача)';
                    this.$eventBus.$emit('refreshHorizontalBarChart', {barTitle: barTitle});
                    this.$eventBus.$emit('refreshMixedBarChart', {barTitle: barTitle});

                    barTitle2 = barTitleText + ' ойлар буйича(' + formatDateText(this.filter.startDate) + ' дан  ' + formatDateText(this.filter.endDate) + ' гача)';
                    this.$eventBus.$emit('refreshBarChartMonth', {barTitle: barTitle2});
                }

                this.filter.region = this.region.id ? this.region : null;
                this.filter.province = this.province.id ? this.province : null;
                if (this.filter.evlObjectType==='AutoAndFitment') {
                    this.$http.post('/report/list/agents', this.filter)
                        .then(res => {
                            // console.log(res);
                            this.results = res.data.data;
                            this.getTotalDataConfig();
                            this.renderingData(this.results);
                            this.loading = false;
                        }, err => {
                            console.log(err);
                            this.loading = false;
                        });
                } else {
                    this.initListRealEstate();
                }
            },
            initListRealEstate() {
                this.$http.post('/report/list/agents/building', this.filter)
                    .then(res => {
                        this.realEstateResults = res.data.data;
                        // console.log("realEstateResults = ");
                        // console.log(this.realEstateResults);
                        this.getTotalDataConfig();
                        this.renderingData(this.realEstateResults);
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            regionalLeaderData(vm, userProvinceId, createUserId, createUserName, contractAmount, paid, unpaid, agentSalary, agentSalaryPaid){
                if ( vm.loginUserProvinceId != null && userProvinceId != null && vm.loginUserProvinceId === userProvinceId) {
                    //by default
                    this.contractAmountTotal.ALL.contractAmount += contractAmount;
                    this.contractAmountTotal.ALL.paid += paid;
                    this.contractAmountTotal.ALL.unpaid += unpaid;

                    this.contractAmountTotal.ALL.agentSalary += agentSalary;
                    this.contractAmountTotal.ALL.agentSalaryPaid += agentSalaryPaid;
                    this.contractAmountTotal.ALL.count++;

                    var findItem = findBy(this.contractAmountTotal.ALL.users, "createUserId", createUserId);
                    if (findItem != null) {
                        findItem.contractAmount += contractAmount;

                        findItem.agentSalary += agentSalary;
                        findItem.agentSalaryPaid += agentSalaryPaid;
                    } else {
                        this.contractAmountTotal.ALL.users.push(
                            {
                                createUserId: createUserId,
                                createUserName: createUserName,
                                contractAmount: contractAmount,
                                paid: paid,
                                unpaid: unpaid,
                                agentSalary: agentSalary,
                                agentSalaryPaid: agentSalaryPaid
                            }
                        );
                    }
                }
            },
            renderingData(results){
                const vm = this;
                const regionalLeader = vm.$store.state.profile.regionalLeader;
                if (regionalLeader){
                    const regionalLeaderProvince = regionalLeader.userProvinces[0];
                    vm.loginUserProvinceId = regionalLeaderProvince.id;
                }

                // console.log("results = ");
                // console.log(results);
                for (var i = 0; i < results.length; i++) {
                    // console.log(this.results[i].contractAmount);
                    const authorities = results[i].authorities;
                    const role_appraiser_helper = authorities.includes('ROLE_APPRAISER_HELPER');
                    const userProvinceId = results[i].userProvinceId;
                    if (role_appraiser_helper) {
                        const contractAmount = parseFloat(results[i].contractAmount);
                        const paid = parseFloat(results[i].paid);
                        const unpaid = parseFloat(results[i].unpaid);
                        const agentSalary = parseFloat(results[i].agentSalory);
                        const agentSalaryPaid = parseFloat(results[i].agentSaloryPaid);
                        // var dt = new Date(results[i].createDate);
                        // const month = (dt.getMonth());
                        // const provinceDto = results[i].provinceDto;
                        // const regionDto = results[i].regionDto;
                        const createUserId = results[i].createUserId;
                        const createUserName = results[i].createUserName;

                        if(vm.$store.state.isRegionalLeader){
                            vm.regionalLeaderData(vm, userProvinceId, createUserId, createUserName, contractAmount, paid, unpaid, agentSalary, agentSalaryPaid);
                        } else {
                            //by default
                            this.contractAmountTotal.ALL.contractAmount += contractAmount;
                            this.contractAmountTotal.ALL.paid += paid;
                            this.contractAmountTotal.ALL.unpaid += unpaid;

                            this.contractAmountTotal.ALL.agentSalary += agentSalary;
                            this.contractAmountTotal.ALL.agentSalaryPaid += agentSalaryPaid;
                            this.contractAmountTotal.ALL.count++;

                            var findItem = findBy(this.contractAmountTotal.ALL.users, "createUserId", createUserId);
                            if (findItem != null) {
                                findItem.contractAmount += contractAmount;

                                findItem.agentSalary += agentSalary;
                                findItem.agentSalaryPaid += agentSalaryPaid;
                            } else {
                                this.contractAmountTotal.ALL.users.push(
                                    {
                                        createUserId: createUserId,
                                        createUserName: createUserName,
                                        contractAmount: contractAmount,
                                        paid: paid,
                                        unpaid: unpaid,
                                        agentSalary: agentSalary,
                                        agentSalaryPaid: agentSalaryPaid
                                    }
                                );
                            }
                        }




                    }

                    // console.log(this.contractAmountTotal);
                }

                this.$eventBus.$emit('refreshPieChart', {
                    title: "Авто ва Асбоб-ускуналар буйича",
                    user: this.filter.user,
                    data: this.contractAmountTotal
                });
            },
            getTotalDataConfig: function () {
                this.contractAmountTotal = {
                    ALL: {
                        contractAmount: 0,
                        paid: 0,
                        unpaid: 0,
                        agentSalary: 0,
                        agentSalaryPaid: 0,
                        count: 0,
                        users: []
                    }
                };
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            init() {
                const vm = this;
                const promises = [
                    this.$http.get('province/init')
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                    vm.initProvinceRegions();
                });
            },

            updateCheckEvaluationObject: function () {
                if (this.selectedEvaluationObject.length > 1) {
                    this.$delete(this.selectedEvaluationObject, 0);
                }
                this.salePropertyDto.evaluationObjectId = this.selectedEvaluationObject[0];
            },
            updateCheckNumberLot: function () {
                if (this.selectedNumberLot.length > 1) {
                    this.$delete(this.selectedNumberLot, 0);
                }
                this.salePropertyDto.numberLot = this.selectedNumberLot[0];
            },
            // saveSalesDay: function () {
            //     this.loading = true;
            //     this.$http.post('/sale/property/save/', this.salePropertyDto).then(res => {
            //         this.loading = false;
            //         if (res.data) {
            //             this.$swal({
            //                 title: this.$t('messages.common.success'),
            //                 text: this.$t('messages.building.success'),
            //                 type: 'success'
            //             });
            //         }
            //     }, err => {
            //         console.log(err);
            //     });
            //
            // },
            onUsersSearch(searchTxt, loading) {
                loading(true);
                this.users = [];
                this.filter.search = searchTxt;
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.users = res.data.data;
                        loading(false);
                        this.filter.search = '';
                    }, err => {
                        console.log(err);
                        loading(false);
                    });
            },
            onUsersFocus() {
                this.users = [];
                this.filter.search = '';
                this.filter.region = this.region;
                this.filter.province = this.province;
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.users = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            sendRequirement: function () {
                this.$http.get('/send/message/file/' + this.evaluationObjectIds.toString())
                    .then(res => {
                        console.log(res.data.data);
                    }, err => {
                        console.log(err);
                    });
            },
            requirementPdf: function () {
                console.log(this.evaluationObjectIds);
                this.$http.get('/requirementReport/pdf/' + this.evaluationObjectIds.toString() + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
                    .then(response => {

                        let blob = new Blob([response.data], {type: 'application/pdf'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Талабнома.pdf';
                        link.click()
                    })
            },
            reportXslx: function () {
                this.$http.post('/getAccountingReportExcel/xls/FITMENT_REPORT_VALUABLE_XLS/',this.filter, {responseType: 'arraybuffer'})
                    .then(res => {
                        let blob = new Blob([res.data], {type: 'application/xlsx'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Xisobot.xlsx';
                        link.click();
                    }, err => {
                        console.log(err);
                    });
            },
            onProvinceChange() {
                this.initProvinceRegions();
            },
            initProvinceRegions() {
                let regions = [];
                if (this.province && this.province.id && this.province.id > 0 && this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.province.id && province.regions && province.regions.length > 0) {
                            regions = province.regions;
                        }
                    });
                }
                this.regions = regions;
            }
        },

        created() {
            this.filter.evlObjectType='AutoAndFitment';

            var d = new Date();
            var currMonth = d.getMonth();
            var currYear = d.getFullYear();
            this.filter.startDate = new Date(currYear, currMonth, 1);
            this.filter.endDate = new Date(currYear, currMonth, d.getDate());


            this.initList();
        },
    }
</script>
<style>
    .scroll-card-body {
        overflow-x: scroll;
        overflow-y: visible;
    }

    td {
        border-top: 1px solid #dee2e6;
    }

    th, td {
        padding: .5rem;
        /*cursor: col-resize;*/
        white-space: nowrap;
    }

    .tdpaid {
        color: red;
    }

    .tdunpaid {
        background-color: transparent;
    }
</style>

